import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class EmailService {
    API_EMAIL_URL = config.serverAddress + ':' + config.serverPort + '/email/';

    constructor(private http: HttpClient) { }
    send(email: any) {
        return this.http.post(this.API_EMAIL_URL + 'send', email);
    }
    sendReminder(id: number) {
        return this.http.post(this.API_EMAIL_URL + 'send-reminder', { IDRequest: id });
    }
    sendDimensionalProspectus(id: number) {
        return this.http.post(this.API_EMAIL_URL + 'send-dimensional-prospectus', { IDRequest: id });
    }
}
